// A temporary list until the DMS adds a type field
export default ['800', '811', '822', '833', '844', '855', '866', '877', '888', '899'];
